import { Box, Typography } from '@mui/material';
import { NoSuggestionsTextField } from '../../../../components/textFields';

function CreateMenu({ name, description, setName, setDescription }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      {/* Nombre del Menú */}
      <NoSuggestionsTextField
        autoFocus
        required
        margin="dense"
        id="create-menu-name"
        name="create-menu-name"
        label="Nombre del Menú"
        type="text"
        fullWidth
        onChange={(e) => setName(e.target.value)}
        value={name}
        autoComplete="off"
        inputProps={{
          autoComplete: 'off',
          'aria-autocomplete': 'none',
          role: 'presentation',
          spellCheck: 'false',
        }}
      />

      {/* Descripción del Menú — multiline mejorado */}
      <Box>
        <Typography
          variant="caption"
          sx={{
            color: '#64748B',
            fontWeight: 600,
            mb: 0.5,
            display: 'block',
            fontSize: '0.78rem',
            textTransform: 'uppercase',
            letterSpacing: '0.4px',
          }}
        >
          Descripción
        </Typography>
        <NoSuggestionsTextField
          required
          margin="none"
          id="create-menu-description"
          name="create-menu-description"
          label=""
          placeholder="Describe brevemente este menú (horario, ocasión, tipo de cocina…)"
          multiline
          minRows={3}
          maxRows={6}
          fullWidth
          onChange={(e) => setDescription(e.target.value)}
          value={description}
          autoComplete="off"
          inputProps={{
            autoComplete: 'off',
            'aria-autocomplete': 'none',
            role: 'presentation',
            spellCheck: 'false',
            style: { resize: 'none' },
          }}
          sx={{
            '& .MuiInputBase-root': {
              alignItems: 'flex-start',
              borderRadius: '14px',
              padding: '12px 14px',
            },
            '& .MuiInputBase-input': {
              fontSize: '0.9rem',
              lineHeight: 1.6,
            },
          }}
        />
        <Typography
          variant="caption"
          sx={{ color: '#94A3B8', mt: 0.5, display: 'block', textAlign: 'right' }}
        >
          {description.length} / 300 caracteres
        </Typography>
      </Box>
    </Box>
  );
}

export default CreateMenu;
